<template>
  <div class="z-0 relative h-full" v-click-outside="onClickOutside">
    <div class="flex-1 h-full px-4 flex items-center justify-between sm:px-6 lg:max-w-6xl lg:mx-auto lg:px-8">
      <div class="flex-1 flex">
        <form class="w-full flex md:ml-0" action="#" method="GET">
          <label for="search-field" class="sr-only">Search</label>
          <div class="relative w-full text-gray-400 focus-within:text-gray-600">
            <div class="absolute inset-y-0 left-0 flex items-center pointer-events-none" aria-hidden="true">
              <base-spinner v-if="isLoading" :size="20" />
              <search-icon class="h-5 w-5 transition-colors duration-100" v-else />
            </div>
            <input
              id="search-field"
              name="search-field"
              class="block w-full h-full pl-8 pr-3 py-2 border-transparent text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-0 focus:border-transparent sm:text-sm"
              :placeholder="memberSearchPlaceholder"
              type="search"
              v-model="query"
            />
          </div>
        </form>
      </div>
    </div>
    <transition
      enter-active-class="transtion ease-out duration-200"
      enter-from-class="opacity-0 -translate-y-1"
      enter-to-class="opacity-100 translate-y-0"
      leave-active-class="transtion ease-in duration-150"
      leave-from-class="opacity-100 -translate-y-0"
      leave-to-class="opacity-0 translate-y-1"
    >
      <div class="absolute mt-0.5 z-10 w-full inset-x-0 transform shadow-lg bg-white rounded sm:left-5 lg:max-w-6xl lg:mx-auto lg:left-7" v-show="showDropdown && !isLoading">
        <div v-if="customers.length">
          <div
            v-for="customer in customers"
            :key="customer.userId"
            class="px-4 py-2.5 hover:bg-gray-100 transition-colors duration-100 cursor-pointer"
            @click="goToMember(customer.userId)"
          >
            <div>{{ customer.fullName }}</div>
            <div class="flex flex-row">
              <div class="text-xs text-gray-500 -mt-1">{{ customer.email }}</div>
              <base-phone-number-field class="text-xs text-gray-500 -mt-1 ml-2" :model-value="customer.phone" :isHyperlinkActive="false" />
            </div>
          </div>
        </div>
        <div class="flex justify-center text-gray-500 p-4" v-else>No results</div>
      </div>
    </transition>
  </div>
</template>

<script>
import debounce from "debounce";

import { mapGetters } from "vuex";
import { SearchIcon } from "@/assets/svgs";

export default {
  components: { SearchIcon },

  props: {
    businessId: String,
  },
  data() {
    return {
      query: "",
      showDropdown: false,
      isLoading: false,
      customers: [],
    };
  },
  computed: {
    ...mapGetters("organization", ["organization"]),
    memberSearchPlaceholder() {
      return `Search ${this.organization.customerLabelPlural}`;
    },
  },
  watch: {
    query() {
      if (this.query.length > 0) {
        this.getMembers();
      } else {
        this.showDropdown = false;
        this.customers = [];
      }
    },
  },
  methods: {
    getMembers: debounce(function () {
      this.isLoading = true;
      this.showDropdown = true;
      this.$axios
        .get(`/businesses/${this.businessId}/members/?skip=0&take=10&query=${encodeURIComponent(this.query)}`)
        .then((res) => {
          this.isLoading = false;
          const { items = [] } = res.data;
          this.customers = items;
        })
        .catch(() => {
          this.isLoading = false;
        });
    }, 500),
    goToMember: function (id) {
      let path;
      if (this.organization.usePrescriptionProgramSetting) {
        path = `/businesses/${this.businessId}/members/${id}/prescriptions`;
      } else {
        path = `/businesses/${this.businessId}/members/${id}/plans`;
      }
      if (this.$route.path !== path) {
        this.$router.push(path);
        this.showDropdown = false;
        setTimeout(() => {
          this.query = "";
        }, 150);
      }
    },
    onClickOutside() {
      this.showDropdown = false;
    },
    didFocus() {
      if (this.query) {
        this.showDropdown = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/vars.scss";

#MemberSearchDropdown {
  position: absolute;
  top: 40px;
}

.spinner {
  min-width: 100px;
}
</style>
